export default __webpack_public_path__ + "static/media/bitcoin.39e8916e.svg";